<script>
  import Form from "@svelteschool/svelte-forms";

  let values;
  const urlParams = new URLSearchParams(window.location.search);
  const key = urlParams.get("k");
  const apiVer = urlParams.get("apiver") || "api";
  console.log("using apiVer", apiVer);

  const baseUrl = `https://${apiVer}.rghm.ir/directSales/newSale`
  // const baseUrl = "http://localhost:3000/directSales/newSale";

  async function send(e) {
    e.target.disabled = true;

    function error(mess) {
      alert(mess);
      e.target.disabled = false;
    }

    const price = Number(values.price);
    const durationDays = Number(values.durationDays);
    let discount = Number(values.discount);

    if (!values.phone) return error("شماره تلفن ضروری است!");
    if (isNaN(price)) return error("مبلغ ضروری است!");
    if (isNaN(durationDays)) return error(" مدت روز های اشتراک ضروری است!");
    if (isNaN(discount)) discount = 0;

    const phone = "+98" + values.phone.substr(values.phone.length - 10);
    if (phone.length !== 13) return error("شماره تلفن اشتباه هست");

    try {
      console.log("fetching")
      const response = await fetch(baseUrl, {
        method: "POST",
        headers: {
          Authorization: key,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          phone,
          price,
          durationDays,
          type: values.type,
          discount,
        }),
      });

      const result = await response.json();
      console.log(result);

      if (response.status !== 200) return error("خطایی رخ داد");
      alert("انجام شد");
    } catch (e) {
      console.error(e)
      error("خطایی رخ داد");
    }
  }
</script>

<style>
  fieldset {
    margin: 0 auto;
    padding: 10px 0;
    border: none;
  }

  div {
    display: block;
    margin: 0 auto;
    max-width: 400px;
  }

  input,
  select {
    display: block;
    margin: 0 auto;
  }

  label,
  h1 {
    display: block;
    padding: 10px;
    text-align: center;
  }

  button {
    display: block;
    padding: 10px;
    margin: 20px auto;
    width: 150px;
  }
</style>

<div>
  <h1>Subscription panel</h1>
  <Form bind:values>
    <fieldset>
      <input placeholder="Customer phone" type="numeric" name="phone" />
    </fieldset>
    <fieldset>
      <input placeholder="Price" type="numeric" name="price" />
    </fieldset>
    <fieldset>
      <input placeholder="Duration days" type="numeric" name="durationDays" />
    </fieldset>
    <fieldset>
      <input placeholder="Discount (Optional)" type="numeric" name="discount" />
    </fieldset>
    <label for="type">Select type:</label>
    <select id="type" name="type">
      <option value="card-to-card">Card to card</option>
      <option value="gift">Gift</option>
    </select>
  </Form>

  <button on:click={send}>Submit</button>
</div>
